const state = {
  list: [],
}

const getters = {
}

const mutations = {
  setList (state, data) {
    state.list = data
  },
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/dgorder-address/search', { params }).then(res => {
      commit('setList', res.data.list)
      return res
    })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/v1frontend/dgorder-address/view', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder-address/create', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder-address/update', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/v1frontend/dgorder-address/delete', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
